<template>
  <DeleteContact
    :confirm-message="$t('Are you sure you want to delete this recruiter?')"
    :confirm-button-text="$t('Yes, delete recruiter')"
    :on-confirm="runDeleteMutation"
    :show="show"
    @cancel="toggleModal"
  >
    <WdsMenuOption v-if="asMenuOption" @click.stop="toggleModal">
      <WdsIcon :size="16" name="trash-can" />
      {{ $t('Delete') }}
    </WdsMenuOption>

    <WdsButtonText v-else @click="toggleModal">
      {{ $t('Delete') }}
    </WdsButtonText>
  </DeleteContact>
</template>

<script>
import { WdsIcon, WdsButtonText, WdsMenuOption } from '@worksome/wds-components'
import DeleteContact from '@/components/Contacts/DeleteContact.vue'
import { DeleteCompanyRecruiterMutation } from '@/components/Contacts/CompanyRecruiter/mutations/DeleteCompanyRecruiterMutation'
import { publicApi } from '@/app-bootstrapping/SetUpApollo'

export default {
  components: { DeleteContact, WdsIcon, WdsButtonText, WdsMenuOption },
  props: {
    companyRecruiterId: {
      type: String,
      required: true,
    },
    asMenuOption: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    show: false,
  }),
  methods: {
    async runDeleteMutation() {
      return publicApi
        .mutate({
          mutation: DeleteCompanyRecruiterMutation,
          variables: {
            input: {
              id: this.companyRecruiterId,
            },
          },
          options: {
            clientId: 'publicApi',
          },
        })
        .then((result) => {
          this.toggleModal()
          this.$emit('deleted')
          return result
        })
        .catch((error) => {
          throw error
        })
    },
    toggleModal() {
      this.show = !this.show
    },
  },
}
</script>
